import {setAuthenticated, setConfig, setConnectionStatus, setCurrentState, setServerUrl, setSocketUrl, setToken} from "../../reducers/configSlice";
import {SOCKET_DISCONNECTED, STATE_ACTIVATE} from "../../constants/default";
import {STORAGE} from "../storage";
import { removeSocket} from "../socket/socket";
import {dispatchAction} from "../state/dispatchAction";
import {getState} from "../state/getState";
import { EventBus } from "../EventBus";
import { disconnectSoketi } from '../soketi';

const destroyInstance = async () => {
    await STORAGE.delete("baseUrl")
    dispatchAction(setServerUrl(''))

    await STORAGE.delete("socketUrl")
    dispatchAction(setSocketUrl(null))

    await STORAGE.delete("token")
    dispatchAction(setToken(null))

    // Clear device UUID for token refresh
    await STORAGE.delete("deviceUuid")

    dispatchAction(setCurrentState(STATE_ACTIVATE))
    dispatchAction(setConfig(getState('defaultConfig')))
    dispatchAction(setConnectionStatus(SOCKET_DISCONNECTED))
    dispatchAction(setAuthenticated(false))

    const soketiUrl = await STORAGE.get("soketiUrl");
    if (soketiUrl) {
        disconnectSoketi();
    } else {
        removeSocket()
    }
}

EventBus.on('destroyInstance', destroyInstance);